import { ReactElement } from 'react';
import styles from './ui-search-input.module.scss';
import { fontColor } from '../../styles';
import { UISpacer } from '../ui-spacer';
import { UIIcon } from '../ui-icon';

type UISearchInputProps = {
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    maxLength?: number;
    onChange?: (value: string) => void;
};
export function UISearchInput(props: UISearchInputProps): ReactElement {
    const { value, placeholder, disabled = false, maxLength, onChange } = props;

    const inputClasses = [styles.inputContainer];
    if (disabled) {
        inputClasses.push(styles.inputDisabled);
    }

    return (
        <div className={inputClasses.join(' ')}>
            <UISpacer />
            <UIIcon name="search" size={16} color={fontColor} />
            <input
                className={styles.input}
                type={'text'}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                onChange={(e) => {
                    onChange?.(e.target.value);
                }}
            />
        </div>
    );
}
